

export class DocumentTypeOutputWithStatus implements IDocumentTypeOutputWithStatus {
    /** The auto-generated id of the document type master */
    document_type_id!: number;
    /** The  document type name with 255 character limit */
    document_type_name!: string;
    /** Manage status of user. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IDocumentTypeOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document_type_id = _data["document_type_id"];
            this.document_type_name = _data["document_type_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DocumentTypeOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document_type_id"] = this.document_type_id;
        data["document_type_name"] = this.document_type_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDocumentTypeOutputWithStatus {
    /** The auto-generated id of the document type master */
    document_type_id: number;
    /** The  document type name with 255 character limit */
    document_type_name: string;
    /** Manage status of user. 0 For De-active, 1 For Active */
    status: number;
}

